import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Componentes
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ItemList from '../../components/ItemList/ItemList';
import FriendlyPhrase from '../../components/FriendlyPhrase/FriendlyPhrase';

// Contextos
import { useToast } from '../../contexts/ToastContext';
import { useLoader } from '../../contexts/LoaderContext';
import { useModal } from '../../contexts/ModalContext';

// API
import { useVideoService } from '../../services/videoService';

// Estilos
import styles from './videospage.module.css';

function VideosPage() {
    const navigate = useNavigate();
    
    const { showToast } = useToast();
    const { showModal } = useModal();
    const { showLoader, hideLoader } = useLoader();

    const { listarVideos, deletarVideo } = useVideoService();

    const [videos, setVideos] = useState([]);

    useEffect(() => {
        const carregarVideos = async () => {
            showLoader("Carregando vídeos");
            const response = await listarVideos();

            if (response.success && Array.isArray(response.videos)) {
                const adaptados = response.videos.map(v => ({
                    ...v,
                    name: v.nome
                }));
                setVideos(adaptados);
            } else {
                console.warn("Resposta inesperada ao listar vídeos:", response);
                showToast("Erro ao carregar vídeos", 3000, "error");
            }

            hideLoader();
        };

        carregarVideos();
    }, []);

    const handleEditar = (item) => {
        navigate(`/videos/atualizar/${item.id}`);
    };

    const handleExcluir = (item) => {
        showModal(
            `Excluir ${item.nome}?`,
            'Essa ação não poderá ser desfeita.',
            async () => {
                showLoader("Excluindo vídeo");
                const response = await deletarVideo(item.id);

                if (response.success) {
                    setVideos(prev => prev.filter(video => video.id !== item.id));
                    showToast('Vídeo excluído com sucesso!', 3000, 'success');
                } else {
                    showToast('Erro ao excluir vídeo.', 3000, 'error');
                }

                hideLoader();
            },
            () => {
                showToast('Exclusão cancelada.', 2000);
            }
        );
    };

    const handleAdd = () => {
        navigate(`/videos/adicionarVideo`);
    };

    const handleSelecionar = (item) => {
        console.log("Vídeo selecionado:", item);
    };

    return (
        <div className={styles.VideosPage}>
            <div className={styles.containerTop}>
                <Breadcrumbs />
                <h1 className={styles.title}>Vídeos Cadastrados</h1>
                <FriendlyPhrase page="videos" />
            </div>

            <div className={styles.containerList}>
                <ItemList
                    items={videos}
                    onAdd={handleAdd}
                    onEdit={handleEditar}
                    onDelete={handleExcluir}
                    onClickItem={handleSelecionar}
                    labelField="nome"
                />
            </div>
        </div>
    );
}

export default VideosPage;